import NamedDto from 'modules/base/dto/NamedDto';

export default class PredictionDeviceEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.project = null;
		/** @type {number} */
		this.deviceType = null;
		/** @type {Date} */
		this.lastSeen = null;
		/** @type {number} */
		this.predictionType = null;
		/** @type {number} */
		this.sourceDevice = null;
	}

	/**
	 * @typedef {Object} _PredictionDeviceEditDtoProps
	 * @property {number} project
	 * @property {number} deviceType
	 * @property {Date} lastSeen
	 * @property {number} predictionType
	 * @property {number} sourceDevice
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _PredictionDeviceEditDtoProps} PredictionDeviceEditDtoProps
	 */
	/**
	 *
	 * @param {PredictionDeviceEditDtoProps} props
	 * @returns {PredictionDeviceEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.project = props.project;
		this.deviceType = props.deviceType;
		this.lastSeen = props.lastSeen != null ? new Date(props.lastSeen) : null;
		this.predictionType = props.predictionType;
		this.sourceDevice = props.sourceDevice;
		return this;
	}
}
